<template>
    <div class="Panel">
        <div class="Panel__heading">Motorstats</div>
        <div class="Panel__body Panel__body--hide-overflow">
            <div class="Form__group">
                <label for="send_help_center_questions_to" class="Form__label">
                    Help Center Question Recipient Emails (CSV)
                </label>
                <input type="text"
                       name="recipients"
                       id="recipients"
                       class="Form__text"
                       v-model.trim="form.recipients"
                       @keyup="clearErrors('recipients')"
                       @keyup.enter="send()"
                >
                <div class="Form__error">{{ errors.recipients }}</div>
            </div>

            <div class="Form__group">
                <a href="#" class="Button" @click.prevent="send">Update</a>
            </div>

            <div :class="successClasses">
                Update Successful.
            </div>
        </div>
    </div>
</template>

<script>
    import Form from './../../mixins/form';

    export default {
        data() {
            return {
                form: {
                    recipients: this.recipients,
                },

                errors: {
                    recipients: '',
                },
            }
        },

        mixins: [Form],

        props: {
            recipients: {
                type: String,
            }
        },

        computed: {
            successClasses() {
                return {
                    'HelpCenter__form-success': true,
                    'HelpCenter__form-success--show': this.showSuccess,
                }
            }
        },
    }
</script>